export default __webpack_public_path__ + "static/media/splfCard.6857f702.png";